module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-17.2a01b307.jpg";